import { RootState } from "../../store";

export const selectAccess = (state: RootState) => state.access;